import apiClient from 'ps-components/lib/apiClient';

export const SURVEY_MIGRATION_SETTINGS_INIT = 'SURVEY_MIGRATION_SETTINGS_INIT';
export const SURVEY_MIGRATION_SETTINGS_REVIEW_DATA_CUTS = 'SURVEY_MIGRATION_SETTINGS_REVIEW_DATA_CUTS';
export const GET_SELECTED_SURVEYS_START = 'GET_SELECTED_SURVEYS_START';
export const GET_SELECTED_SURVEYS_SUCCESS = 'GET_SELECTED_SURVEYS_SUCCESS';
export const SET_MIGRATION_DATA = 'SET_MIGRATION_DATA';
export const TOGGLE_DATA_CUT_SHOW = 'TOGGLE_DATA_CUT_SHOW';
export const SET_DATA_CUT_OPTION = 'SET_DATA_CUT_OPTION';
export const SET_TYPE_OF_REVIEW = 'SET_TYPE_OF_REVIEW';
export const SET_AUTO_REVIEW_OPTION = 'SET_AUTO_REVIEW_OPTION';
export const MIGRATION_SLIDE_OUT_CLOSE = 'MIGRATION_SLIDE_OUT_CLOSE';

export const initMigrationSettings = e => {
  return {
    type: SURVEY_MIGRATION_SETTINGS_INIT
  };
};

export const reviewDataCuts = e => {
  return {
    type: SURVEY_MIGRATION_SETTINGS_REVIEW_DATA_CUTS,
    payload: true
  };
};

export const goBackToSettings = e => {
  return {
    type: SURVEY_MIGRATION_SETTINGS_REVIEW_DATA_CUTS,
    payload: false
  };
};

export function getSelectedSurveys(curSurveyYear, newSurveyYear) {
  return async dispatch => {
    try {
      dispatch({ type: GET_SELECTED_SURVEYS_START });
      const results = await apiClient.apiGet('/api/migration/selected-surveys/retrieveSelectedSurveys', {
        params: {
          curSurveyYear: curSurveyYear,
          newSurveyYear: newSurveyYear
        }
      });
      dispatch({ type: GET_SELECTED_SURVEYS_SUCCESS, payload: results.data.result });
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
}

export function setSelectedMigrationData(curSurveyYear, newSurveyYear, gridStore) {
  return async dispatch => {
    try {
      dispatch({
        type: SET_MIGRATION_DATA,
        payload: {
          curSurveyYear: curSurveyYear,
          newSurveyYear: newSurveyYear,
          gridStore: gridStore
        }
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
}

export function toggleDataCutOption() {
  return { type: TOGGLE_DATA_CUT_SHOW };
}

export function setDataCutOption(option) {
  return { type: SET_DATA_CUT_OPTION, payload: option };
}

export function setTypeOfReview(option) {
  return { type: SET_TYPE_OF_REVIEW, payload: option };
}

export function setAutoReviewOption(option) {
  return { type: SET_AUTO_REVIEW_OPTION, payload: option };
}

export function closeSlideout() {
  // Wait for slideout to close before resetting state
  const waitForSlideout = new Promise(resolve => {
    setTimeout(() => {
      resolve({ type: MIGRATION_SLIDE_OUT_CLOSE });
    }, 500);
  });
  return async dispatch => {
    try {
      dispatch(await waitForSlideout);
    } catch (e) {
      console.log(e);
    }
  };
}
